<template>
    <pendo-router-link
        v-pendo-tooltip="{
            classes: 'side-nav-tooltip',
            content: tooltipContent,
            placement: 'right',
            arrow: true,
        }"
        pendo-analytics="replay-nav-item-upsell"
        data-cy="replay-nav-link"
        class="nav-option"
        :class="{ selected, expanded }"
        :to="{ name: 'SessionReplay' }"
        :aria-label="label"
        @click="$emit('toggle', $event)"
        @keyup.enter="$emit('toggle', $event)">
        <div class="nav-icon">
            <svg
                class="filled-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 7.9716C10 7.56491 10.4597 7.32835 10.7906 7.56473L16.4304 11.5931C16.7096 11.7925 16.7096 12.2075 16.4304 12.4069L10.7906 16.4353C10.4597 16.6717 10 16.4351 10 16.0284V7.9716Z"
                    fill="var(--palette-gray-90)"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C10.5778 2 9.22492 2.2969 8 2.83209M2 12C2 13.2313 2.22255 14.4107 2.62961 15.5M4.72257 5.14146C3.81746 6.10149 3.10022 7.24059 2.62961 8.5M4.72257 18.8585C5.6418 19.8335 6.75479 20.6239 8 21.1679"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
            <svg
                class="empty-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 7.9716C10 7.56491 10.4597 7.32835 10.7906 7.56473L16.4304 11.5931C16.7096 11.7925 16.7096 12.2075 16.4304 12.4069L10.7906 16.4353C10.4597 16.6717 10 16.4351 10 16.0284V7.9716Z"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C10.5778 2 9.22492 2.2969 8 2.83209M2 12C2 13.2313 2.22255 14.4107 2.62961 15.5M4.72257 5.14146C3.81746 6.10149 3.10022 7.24059 2.62961 8.5M4.72257 18.8585C5.6418 19.8335 6.75479 20.6239 8 21.1679"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </div>
        <div
            v-show="expanded"
            class="nav-label">
            <span class="label-text">{{ label }}</span>
            <upsell-tag />
        </div>
    </pendo-router-link>
</template>

<script>
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import { PendoTooltip } from '@pendo/components-vue3';
import UpsellTag from '@/common/tags/upsell-tag.vue';

export default {
    name: 'Replay',
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    components: {
        PendoRouterLink,
        UpsellTag,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        selected: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    computed: {
        tooltipContent () {
            if (this.expanded) return '';

            return this.$t('sideNav.Available upgrade: Replay');
        },
        label () {
            return this.$t('sideNav.Replay');
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';
</style>
